var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-tags-simple-list"},_vm._l((_vm.Items),function(item,index){return _c('div',{key:index},[_vm._v("\n        "+_vm._s(item.Value.toString())),(index<_vm.count())?[_vm._v(",  ")]:_vm._e()],2)}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b82be878","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-tags/src/ui-tags-simple-list.vue
// module id = 741
// module chunks = 0